import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1-11V7h2v4h4v2h-4v4h-2v-4H7v-2h4z" }));
export default createSvgIcon(iconPath, "Add");
//# sourceMappingURL=AddIcon.js.map